import { Settings } from "./types";

export function extractAddressFromMapPlace(
  place: Settings.MapPlace
): Settings.Address {
  return {
    address: place.formatted_address,
  };
}
